var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01343 25.89L14.8586 19.1084L40.0862 31.7674L27.4272 38.0969L3.01343 25.89Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09302 22.9061V26.3421L7.35356 25.1666V21.821L5.09302 22.9061Z",
    fill: "#2D3134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M5.09302 22.9061V26.3421L7.35356 25.1666V21.821L5.09302 22.9061Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9913 30.0494C23.3583 29.6877 22.7254 29.6877 22.2733 29.8685L21.0074 30.5015C20.4649 30.6823 20.1936 31.2249 20.1936 31.9482C20.1936 33.3045 21.3691 35.0226 22.7254 35.7459C23.4488 36.1076 24.0817 36.1076 24.5338 35.9268C24.5338 35.9268 25.7997 35.2938 25.8901 35.2034C26.3422 34.9321 26.5231 34.48 26.5231 33.8471C26.5231 32.4003 25.3476 30.6823 23.9913 30.0494Z",
    fill: "#2D3134"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M24.5337 35.8364C24.7145 35.746 25.7996 35.2035 25.89 35.2035C26.3421 34.9322 26.523 34.4801 26.523 33.8472C26.523 33.3046 26.3421 32.6717 26.0709 32.1292L24.805 32.7621C25.0762 33.3046 25.2571 33.9376 25.2571 34.4801C25.2571 35.1131 24.9858 35.6556 24.5337 35.8364Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6244 34.1183C24.6244 35.2034 23.8106 35.5651 22.7255 35.0225C21.6404 34.48 20.8267 33.2141 20.8267 32.1291C20.8267 31.044 21.6404 30.6823 22.7255 31.2248C23.8106 31.7674 24.6244 33.0333 24.6244 34.1183Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.9063 35.0227C21.8213 34.4802 21.0075 33.2143 21.0075 32.1292C21.0075 31.5867 21.1883 31.225 21.55 31.0442C21.0979 31.1346 20.8267 31.5867 20.8267 32.1292C20.8267 33.2143 21.6405 34.4802 22.7255 35.0227C23.268 35.294 23.7201 35.294 24.0818 35.1132C23.7201 35.294 23.3585 35.2036 22.9063 35.0227Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7204 33.4855C23.7204 33.9377 23.3587 34.1185 22.9066 33.8472C22.4545 33.576 22.0928 33.1239 22.0928 32.6718C22.0928 32.2196 22.4545 32.0388 22.9066 32.3101C23.3587 32.5813 23.7204 33.0334 23.7204 33.4855Z",
    fill: "#2D3134"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M23.7204 33.4855C23.7204 33.9377 23.3587 34.1185 22.9066 33.8472C22.4545 33.576 22.0928 33.1239 22.0928 32.6718C22.0928 32.2196 22.4545 32.0388 22.9066 32.3101C23.3587 32.5813 23.7204 33.0334 23.7204 33.4855Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.539 33.5759C23.539 34.028 23.1773 34.2088 22.7252 33.9376C22.2731 33.7567 21.9114 33.2142 21.9114 32.7621C21.9114 32.31 22.2731 32.1291 22.7252 32.4004C23.1773 32.5812 23.539 33.1238 23.539 33.5759Z",
    fill: "#2D3134"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M25.2572 34.48C25.2572 35.8363 24.0817 36.4692 22.7254 35.7459C21.3691 35.0225 20.1936 33.3045 20.1936 31.9482C20.1936 30.5919 21.3691 29.9589 22.7254 30.6823C24.0817 31.3152 25.2572 33.0332 25.2572 34.48Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07162 22.5445C8.43867 22.1828 7.80572 22.1828 7.35361 22.3637L6.08772 22.9966C5.63561 23.1775 5.27393 23.72 5.27393 24.4433C5.27393 25.7997 6.4494 27.5177 7.80572 28.241C8.52909 28.6027 9.16204 28.6027 9.61414 28.4219C9.61414 28.4219 10.88 27.7889 10.9705 27.6985C11.4226 27.4272 11.6034 26.9751 11.6034 26.3422C11.6034 24.9859 10.4279 23.2679 9.07162 22.5445Z",
    fill: "#2D3134"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M9.61401 28.4219C9.79486 28.3315 10.8799 27.7889 10.9703 27.7889C11.4224 27.5177 11.6033 27.0656 11.6033 26.4326C11.6033 25.8901 11.4224 25.2571 11.1512 24.7146L9.88528 25.3476C10.1565 25.8901 10.3374 26.523 10.3374 27.0656C10.3374 27.6985 10.0661 28.1506 9.61401 28.4219Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70467 26.7038C9.70467 27.7888 8.89088 28.1505 7.80583 27.608C6.72077 27.0655 5.90698 25.7996 5.90698 24.7145C5.90698 23.6294 6.72077 23.2678 7.80583 23.8103C8.89088 24.3528 9.70467 25.6187 9.70467 26.7038Z",
    fill: "#999999"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M7.98667 27.5178C6.90162 26.9753 6.08783 25.7094 6.08783 24.6244C6.08783 24.0818 6.26867 23.7201 6.63035 23.5393C6.17825 23.6297 5.90698 24.0818 5.90698 24.6244C5.90698 25.7094 6.72077 26.9753 7.80583 27.5178C8.34836 27.7891 8.80046 27.7891 9.16215 27.6083C8.80046 27.7891 8.43878 27.7891 7.98667 27.5178Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80068 26.071C8.80068 26.5231 8.43899 26.7039 7.98689 26.4327C7.53478 26.2518 7.1731 25.7093 7.1731 25.2572C7.1731 24.8051 7.53478 24.6243 7.98689 24.8955C8.43899 25.0764 8.80068 25.6189 8.80068 26.071Z",
    fill: "#2D3134"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M8.80068 26.071C8.80068 26.5231 8.43899 26.7039 7.98689 26.4327C7.53478 26.2518 7.1731 25.7093 7.1731 25.2572C7.1731 24.8051 7.53478 24.6243 7.98689 24.8955C8.43899 25.0764 8.80068 25.6189 8.80068 26.071Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61928 26.071C8.61928 26.5231 8.2576 26.7039 7.80549 26.4327C7.35338 26.1614 6.9917 25.7093 6.9917 25.2572C6.9917 24.8051 7.35338 24.6243 7.80549 24.8955C8.2576 25.1668 8.61928 25.7093 8.61928 26.071Z",
    fill: "#2D3134"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M10.3375 26.9751C10.3375 28.3314 9.16205 28.9644 7.80573 28.241C6.44941 27.5176 5.27393 25.7996 5.27393 24.4433C5.27393 23.087 6.44941 22.454 7.80573 23.1774C9.16205 23.9008 10.3375 25.6188 10.3375 26.9751Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6724 1.20508L3.01343 7.53458V21.3691L19.2893 29.507L31.9483 22.9062V9.34301L15.6724 1.20508Z",
    fill: "#FFB600"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01343 20.1936V22.002L19.2893 30.1399V28.3315L3.01343 20.1936Z",
    fill: "#2D3134"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9483 22.002V23.8104L19.2893 30.1399V28.3314L31.9483 22.002Z",
    fill: "#2D3134"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M3.01343 7.53467V22.0021L19.2893 30.14V15.6726L3.01343 7.53467Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M31.9483 9.34302V23.8105L19.2893 30.14V15.6725L31.9483 9.34302Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2778 16.5767L32.8526 13.864L20.1936 20.1935V30.4111C20.1936 30.6824 20.5553 30.8632 20.8266 30.6824C21.9116 29.7782 23.8105 30.4111 25.1668 32.0387C25.9806 33.0333 26.3422 34.1184 26.3422 35.0226L27.4273 35.5651L40.0863 29.2356V22.0019L38.2778 16.5767Z",
    fill: "#E5E5E5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7889 27.8793L26.2518 23.3582C26.1614 23.1774 26.2518 23.087 26.4326 22.9966L37.7353 17.3905C37.9161 17.3 38.097 17.3905 38.1874 17.5713L39.6341 21.8211C39.7245 22.0019 39.6341 22.0924 39.4533 22.1828L28.241 28.0601C28.0602 28.1506 27.7889 28.0601 27.7889 27.8793Z",
    fill: "#3399CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M29.8687 21.2786L37.6449 17.3905C37.8257 17.3 38.0066 17.3905 38.097 17.5713L39.4533 21.5498L29.8687 21.2786Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5438 21.8211L39.4534 21.5498C39.4534 21.7306 39.4534 21.8211 39.2725 21.9115L28.0603 27.7889C27.8794 27.8793 27.6986 27.7889 27.6082 27.608L27.6986 27.8793C27.789 28.0601 27.9698 28.1506 28.1507 28.0601L39.3629 22.1828C39.5438 22.0923 39.6342 22.0019 39.5438 21.8211Z",
    fill: "#2D3134"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5918 27.4272L36.9213 24.2625V29.5069L30.5918 32.6716V27.4272Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 31.9483L36.4695 29.2356V24.9858L31.0442 27.6985V31.9483Z",
    fill: "#2D3134"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0862 29.2357V27.4272L27.4272 33.7567V35.5652L40.0862 29.2357Z",
    fill: "#2D3134"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6189 34.661L27.4273 35.5652V33.7568L25.6189 32.8525V34.661Z",
    fill: "#2D3134"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 31.9482V32.8524L36.4695 30.1398V29.2356L31.0442 31.9482Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1665 23.1775L21.7305 21.4595C21.6401 21.3691 21.4592 21.4595 21.4592 21.6404V24.353C21.4592 24.5339 21.5497 24.7147 21.7305 24.7147L22.906 25.3477C22.9964 25.4381 23.0868 25.4381 23.1772 25.5285L24.3527 26.9752C24.3527 26.9752 24.3527 26.9752 24.4431 26.9752L26.4324 27.9699C26.5228 28.0603 26.7037 27.8795 26.6133 27.789L25.0761 23.268C25.2569 23.268 25.2569 23.1775 25.1665 23.1775Z",
    fill: "#3399CC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M26.7942 27.6986L24.9858 26.7944C24.9858 26.7944 24.9858 26.7944 24.8954 26.7944L23.7199 25.3477C23.6295 25.2572 23.5391 25.1668 23.4487 25.1668L22.2732 24.5339C22.0923 24.4435 22.0019 24.353 22.0019 24.1722V21.55L21.8211 21.4595C21.7306 21.3691 21.5498 21.4595 21.5498 21.6404V24.353C21.5498 24.5339 21.6402 24.7147 21.8211 24.7147L22.9965 25.3477C23.087 25.4381 23.1774 25.4381 23.2678 25.5285L24.4433 26.9753C24.4433 26.9753 24.4433 26.9753 24.5337 26.9753L26.523 27.9699C26.7038 28.0603 26.7942 27.9699 26.7942 27.6986Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4272 31.9482V33.7566L26.9751 33.5758V31.7673L27.4272 31.9482Z",
    fill: "#FFCC00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 28.3315V28.6028L36.4695 25.8902V25.6189L31.0442 28.3315Z",
    fill: "#E5E5E5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 29.2356V29.5068L36.4695 26.7942V26.5229L31.0442 29.2356Z",
    fill: "#E5E5E5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 30.1399V30.4111L36.4695 27.6985V27.4272L31.0442 30.1399Z",
    fill: "#E5E5E5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0442 31.0442V31.3154L36.4695 28.6028V28.3315L31.0442 31.0442Z",
    fill: "#E5E5E5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.5498 25.8901V26.3422L22.454 26.7944V26.3422L21.5498 25.8901Z",
    fill: "#2D3134"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.454 26.9752L21.5498 26.5231V26.3423L22.454 26.7944V26.9752Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2089 21.9116C34.1185 21.8211 34.0281 21.8211 33.9377 21.9116L30.5017 25.7997C30.4112 25.8901 30.4112 25.9805 30.5017 26.0709C30.5921 26.1614 30.6825 26.1614 30.7729 26.0709L31.6771 24.9859V25.8901H31.9484V24.7146L34.2089 22.0924C34.2994 22.0924 34.2994 21.9116 34.2089 21.9116Z",
    fill: "#2D3134"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4638 20.1032C37.3734 20.0128 37.283 20.0128 37.1926 20.1032L33.7565 23.9913C33.6661 24.0818 33.6661 24.1722 33.7565 24.2626C33.847 24.353 33.9374 24.353 34.0278 24.2626L34.8416 23.3584V24.353H35.1129V23.0871L37.4638 20.3745C37.5542 20.2841 37.5542 20.1936 37.4638 20.1032Z",
    fill: "#2D3134"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2778 28.3315L40.0863 27.4273V25.6189L39.182 26.071C38.6395 26.3423 38.2778 26.8848 38.2778 27.5177V28.3315Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.6162 26.7456C38.364 27.0554 38.3165 27.4344 38.5102 27.592C38.7039 27.7497 39.0653 27.6263 39.3175 27.3164C39.5697 27.0066 39.6172 26.6276 39.4235 26.47C39.2299 26.3123 38.8684 26.4357 38.6162 26.7456Z",
    fill: "#2D3134"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.0681 26.7456C38.8159 27.0554 38.7684 27.4344 38.9621 27.592C39.1558 27.7497 39.5172 27.6263 39.7694 27.3164C40.0216 27.0066 40.0691 26.6276 39.8754 26.47C39.6818 26.3123 39.3203 26.4357 39.0681 26.7456Z",
    fill: "#2D3134"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.2778 28.3315L40.0863 27.4273V25.6189L38.2778 28.3315Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4272 33.7569L29.2357 32.8527V32.0389C29.2357 31.5868 28.7836 31.3155 28.3315 31.4963L27.4272 31.9484V33.7569Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.2175 32.1701C27.9653 32.48 27.9178 32.859 28.1115 33.0166C28.3052 33.1742 28.6666 33.0508 28.9188 32.741C29.171 32.4311 29.2185 32.0521 29.0248 31.8945C28.8312 31.7369 28.4697 31.8603 28.2175 32.1701Z",
    fill: "#2D3134"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.7656 32.1701C27.5134 32.48 27.4659 32.859 27.6596 33.0166C27.8533 33.1742 28.2147 33.0508 28.4669 32.741C28.7191 32.4311 28.7666 32.0521 28.5729 31.8945C28.3793 31.7369 28.0178 31.8603 27.7656 32.1701Z",
    fill: "#2D3134"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.4272 33.7569L29.2357 32.8527L27.4272 31.9485V33.7569Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M25.6189 22.9062L20.1936 20.1936V30.4112C20.1936 30.6825 20.5553 30.8633 20.8266 30.6825C21.9116 29.7783 23.8105 30.4112 25.1668 32.0388C25.438 32.3101 25.6189 32.5813 25.7093 32.943L25.6189 32.8526V34.661L27.4273 35.5653V33.7568V28.3315L25.6189 22.9062Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M38.2779 16.5767L25.6189 22.9062L27.4273 28.3314V35.5651L40.0863 29.2357V22.0019L38.2779 16.5767Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSmall);
export default __webpack_public_path__ + "static/media/truckSmall.b026da0085ca019b2fb3da4e8dcaa8a6.svg";
export { ForwardRef as ReactComponent };